import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import IconPicker from './icon-picker/index';
import icon_box from '../icons/icon-box' 
import color_palette_list from '../gb-helper/color_palette'

const { registerBlockType } = wp.blocks; 
const { __ } = wp.i18n;
const { InspectorControls, BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar, RichText, MediaUploadCheck, MediaUpload } = wp.editor;
const { PanelBody, PanelRow, SelectControl, Dashicon, Card, CardBody, Button,
    RangeControl, ColorIndicator, ColorPalette, ToggleControl } = wp.components;

registerBlockType('blocksbakery/icon-box', {
    title: __('Icon Box', 'blocks-bakery'),
    description: __(
        'This block helps you add an Icon With Heading and Sub Heading',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: icon_box.icon_box,
    keywords: [
        __('icon Box', 'blocks-bakery'),
        __('image', 'blocks-bakery'),
        __('box', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    "attributes": {

        "icon_selector": {
            "type": "string",
            "default": "fas fa-truck"
        },
        "ibheading": {
            "type": "string",
            "default": "Write a Heading"
        },
        "ibheadingtag": {
            "type": "string",
            "default": "h1"
        },
        "ibpara": {
            "type": "string",
            "default": "Paragraph"
        },
        "icon_size": {
            "type": "number",
            "default": 30
        },
        "headingml": {
            "type": "number",
            "default": 0
        },
        "headingmr": {
            "type": "number",
            "default": 10
        },
        "headingmt": {
            "type": "number",
            "default": 0
        },
        "headingmb": {
            "type": "number",
            "default": 0
        },
        "iconposition": {
            "type": "string",
            "default": "default"
        },
        "iconpositionVertical": {
            "type": "string",
            "default": 'top'
        },
        "title_family": {
            "type": "string",
            "default": "ABeeZee"
        },
        "title_weight": {
            "type": "string",
            "default": "regular"

        },
        "font_sizeib": {
            "type": "number",
            "default": "",

        },
        "title_height": {
            "type": "number",
            "default": 1.5
        },
        "letter_spacing_title": {
            "type": "number",
            "default": 0
        },
        "description_family": {
            "type": "string",
            "default": "ABeeZee"
        },
        "description_weight": {
            "type": "string",
            "default": "regular"
        },
        "description_sizeib": {
            "type": "number",
            "default": 16
        },
        "description_line_Height": {
            "type": "number",
            "default": 1.5
        },
        "letter_spacing_desc": {
            "type": "number",
            "default": 0
        },
        "text_colr": {
            "type": "string",
            "default": "black"
        },
        "para_clr": {
            "type": "string",
            "default": "black"
        },
        "icon_clr": {
            "type": "string",
            "default": "black"
        },
        "bg_wrap": {
            "type": "string",
            "default": "transparent"
        },
        "ic_b_clr": {
            "type": "string",
            "default": "red",
        },
        "pl_wrap": {
            "type": "number",
            "default": 0
        },
        "pr_wrap": {
            "type": "number",
            "default": 0
        },
        "pt_wrap": {
            "type": "number",
            "default": 0
        },
        "pb_wrap": {
            "type": "number",
            "default": 0
        },
        "icon_border": {
            "type": "number",
            "default": 0
        },
        "icon_radius": {
            "type": "number",
            "default": 0
        },
        "ic_bg_clr": {
            "type": "string",
            "default": "transparent"
        },
        "icon_padding": {
            "type": "number",
            "default": 0
        },
        "border_style": {
            "type": "string",
            "default": "none"
        },
        "display_default": {
            "type": "string",
            "default": "block"

        },
        "display_left": {
            "type": "string",
            "default": "none"
        },
        "display_right": {
            "type": "string",
            "default": "none"
        },
        "alg": {
            "type": "string",
            "default": "flex-start"
        },
        "wrap_border_radius": {
            "type": "number",
            "default": 0
        },
        "text_alignment": {
            "type": "string",
            "default": "center"
        },
        "title_transform": {
            "type": "string",
            "default": "none"
        },
        "title_decoration": {
            "type": "string",
            "default": "none"
        },
        "description_transform": {
            "type": "string",
            "default": "none"
        },
        "description_decoration": {
            "type": "string",
            "default": "none"
        },
        "text_shadow_color_desc": {
            "type": "string",
            "default": "black"
        },
        "horizontal_desc": {
            "type": "number",
            "default": 0
        },
        "vertical_desc": {
            "type": "number",
            "default": 0
        },
        "blur_desc": {
            "type": "number",
            "default": 0
        },
        "text_shadow_color_title": {
            "type": "string",
            "dafault": "yellow"
        },
        "horizontal_title": {
            "type": "number",
            "default": 0
        },
        "vertical_title": {
            "type": "number",
            "default": 0
        },
        "blur_title": {
            "type": "number",
            "default": 0
        },
        "wrapper_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "icon_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "heading_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "paragrpaph_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "vert_align":{
            "type":"string",
            "default": "none"
        }
    },


    edit: (props) => {

        var index = font_family_detailed.findIndex(x => x.family === props.attributes.title_family);
        var font_weight = font_family_detailed[index].variants

        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }


        var indexdesc = font_family_detailed.findIndex(x => x.family === props.attributes.description_family);
        var font_weight_des = font_family_detailed[indexdesc].variants

        var font_weight_list_desc = []
        for (var i = 0; i < font_weight_des.length; i++) {
            font_weight_list_desc.push({ label: font_weight_des[i], value: font_weight_des[i] })
        }
        const postion = (new_val) => {
            var x = document.querySelector(".bb-ib-wrapper");
            if (new_val === 'default') {
                console.log("default")
                x.style.display = "block"
            }
            else if (new_val === 'left') {
                console.log("left")
                var x = document.querySelector(".bb-ib-wrapper");
                x.style.display = "flex"

                x.style.alignItems = "center"
                x.style.flexDirection = "row"
            }
            else if (new_val === 'right') {
                console.log("row-reverse")
                var x = document.querySelector(".bb-ib-wrapper");
                x.style.display = "flex"

                x.style.alignItems = "center"
                x.style.flexDirection = "row-reverse"
            }
        }


        return (
            <React.Fragment>
                <div className="bb-ib-image">
                    <InspectorControls>
                        <PanelBody title={__("Positions")} initialOpen={true}>

                            <SelectControl
                                options={[
                                    { label: 'default', value: 'default' },
                                    { label: 'Left', value: 'left' },
                                    { label: 'Right', value: 'right' },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ iconposition: new_val })
                                    if (new_val === "default") {
                                        props.setAttributes({ display_default: "block" })
                                        props.setAttributes({ display_left: "none" })
                                        props.setAttributes({ display_right: "none" })
                                        props.setAttributes({vert_align:"none"})
                                    }

                                    else if (new_val === "left") {
                                        props.setAttributes({ display_default: "none" })
                                        props.setAttributes({ display_left: "flex" })
                                        props.setAttributes({ display_right: "none" })
                                        props.setAttributes({vert_align:"block"})
                                    }
                                    else if (new_val === "right") {
                                        props.setAttributes({ display_default: "none" })
                                        props.setAttributes({ display_left: "none" })
                                        props.setAttributes({ display_right: "flex" })
                                        props.setAttributes({vert_align:"block"})
                                    }
                                }}

                            />
                            <div style={{display:props.attributes.vert_align}}>
                                <SelectControl
                                    label="Icon Vertical Alignment"
                                    options={[
                                        { label: 'Top', value: 'top' },
                                        { label: 'Middle', value: 'middle' },
                                        { label: 'bottom', value: 'bottom' },
                                    ]}
                                    onChange={(new_val) => {
                                        props.setAttributes({ iconpositionVertical: new_val })
                                        if (new_val === 'top') {
                                            props.setAttributes({ alg: "flex-start" })
                                        }
                                        else if (new_val === 'middle') {
                                            props.setAttributes({ alg: "center" })
                                        }
                                        else if (new_val === 'bottom') {
                                            props.setAttributes({ alg: "flex-end" })
                                        }

                                    }}
                                />
                            </div>
                        </PanelBody>
                        <PanelBody title={__("Icon")} initialOpen={false}>
                            <IconPicker
                                allowReset={false}
                                value={props.attributes.icon_selector}

                                onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                            />

                            <RangeControl
                                label="Icon Size"
                                min={0}
                                max={200}
                                step={0.1}
                                initialPosition={30}
                                value={props.attributes.icon_size}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_size: new_val })
                                }}
                            />
                        </PanelBody>

                        <PanelBody title={__("Title")} initialOpen={false}>
                            <SelectControl
                                label="Title Heading"
                                options={[
                                    { label: 'h1', value: 'h1' },
                                    { label: 'h2', value: 'h2' },
                                    { label: 'h3', value: 'h3' },
                                    { label: 'h4', value: 'h4' },
                                    { label: 'h5', value: 'h5' },
                                    { label: 'h6', value: 'h6' },
                                ]}
                                value={props.attributes.ibheadingtag}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibheadingtag: new_val })
                                }}
                            />
                            <SelectControl
                                label="Font Family"
                                options={all_font_families}
                                onChange={(new_val) => {
                                    props.setAttributes({ title_family: new_val })
                                }}
                                value={props.attributes.title_family}

                            />
                            <SelectControl
                                label="Font Weight"
                                options={
                                    [
                                        { label: '100', value: 100 },
                                        { label: '200', value: 200 },
                                        { label: '300', value: 300 },
                                        { label: '400', value: 400 },
                                        { label: '500', value: 500 },
                                        { label: '600', value: 600 },
                                        { label: '700', value: 700 },
                                        { label: '800', value: 800 },
                                        { label: '900', value: 900 },
                                        { label: 'Default', value: '' },
                                        { label: 'Normal', value: 'normal' },
                                        { label: 'Bold', value: 'bold' }
                                    ]
                                }
                                onChange={(new_val) => {
                                    props.setAttributes({ title_weight: new_val })
                                }}
                                value={props.attributes.title_weight}
                            />

                            <SelectControl
                                label="Text Transform"
                                options={[
                                    { label: "Normal", value: "none" },
                                    { label: "Capitalize", value: "capitalize" },
                                    { label: "Upper Case", value: "uppercase" },
                                    { label: "Lower Case", value: "lowercase" },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ title_transform: new_val })
                                }}
                                value={props.attributes.title_transform}
                            />

                            <SelectControl
                                label="Text Decoration"
                                options={[
                                    { label: "None", value: "none" },
                                    { label: "Overline", value: "overline" },
                                    { label: "Line Through", value: "line-through" },
                                    { label: "Underline", value: "underline" },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ title_decoration: new_val })
                                }}
                                value={props.attributes.title_decoration}
                            />

                            <RangeControl
                                label="Title Font Size (px)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={26}
                                value={props.attributes.font_sizeib}
                                onChange={(new_val) => {
                                    props.setAttributes({ font_sizeib: new_val })
                                }}
                            />

                            <RangeControl
                                label="Title Line Height (em)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={1.5}
                                value={props.attributes.title_height}
                                onChange={(new_val) => {
                                    props.setAttributes({ title_height: new_val })
                                }}
                            />
                            <RangeControl
                                label="Letter Spacing (px)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.letter_spacing_title}
                                onChange={(new_val) => {
                                    props.setAttributes({ letter_spacing_title: new_val })
                                }}
                            />

                            <PanelBody title={__("Text Shadow")} initialOpen={true}>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_color_title: new_val })
                                    }}
                                    value={props.attributes.text_shadow_color_title}
                                />
                                <RangeControl
                                    label="Horizontal (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.horizontal_title}
                                    onChange={(new_val) => {
                                        props.setAttributes({ horizontal_title: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Vertical (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.vertical_title}
                                    onChange={(new_val) => {
                                        props.setAttributes({ vertical_title: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Blur (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.blur_title}
                                    onChange={(new_val) => {
                                        props.setAttributes({ blur_title: new_val })
                                    }}
                                />
                            </PanelBody>

                        </PanelBody>


                        <PanelBody title={__("Description")} initialOpen={false}>
                            < SelectControl
                                label="Font Family"
                                options={all_font_families}
                                onChange={(new_val) => {
                                    props.setAttributes({ description_family: new_val })
                                }}
                                value={props.attributes.description_family}
                            />
                            <SelectControl
                                label="Font Weight"
                                options={
                                    [
                                        { label: '100', value: 100 },
                                        { label: '200', value: 200 },
                                        { label: '300', value: 300 },
                                        { label: '400', value: 400 },
                                        { label: '500', value: 500 },
                                        { label: '600', value: 600 },
                                        { label: '700', value: 700 },
                                        { label: '800', value: 800 },
                                        { label: '900', value: 900 },
                                        { label: 'Default', value: '' },
                                        { label: 'Normal', value: 'normal' },
                                        { label: 'Bold', value: 'bold' }
                                    ]
                                }
                                onChange={(new_val) => {
                                    props.setAttributes({ description_weight: new_val })
                                }}
                                value={props.attributes.description_weight}
                            />

                            <SelectControl
                                label="Text Transform"
                                options={[
                                    { label: "Normal", value: "none" },
                                    { label: "Capitalize", value: "capitalize" },
                                    { label: "Upper Case", value: "uppercase" },
                                    { label: "Lower Case", value: "lowercase" },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ description_transform: new_val })
                                }}
                                value={props.attributes.description_transform}
                            />

                            <SelectControl
                                label="Text Decoration"
                                options={[
                                    { label: "None", value: "none" },
                                    { label: "Overline", value: "overline" },
                                    { label: "Line Through", value: "line-through" },
                                    { label: "Underline", value: "underline" },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ description_decoration: new_val })
                                }}
                                value={props.attributes.description_decoration}
                            />

                            <RangeControl
                                label="Description Font Size (px)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={16}
                                value={props.attributes.description_sizeib}
                                onChange={(new_val) => {
                                    props.setAttributes({ description_sizeib: new_val })
                                }}
                            />

                            <RangeControl
                                label="Description Line Height (em)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={1.5}
                                value={props.attributes.description_line_Height}
                                onChange={(new_val) => {
                                    props.setAttributes({ description_line_Height: new_val })
                                }}
                            />
                            <RangeControl
                                label="Letter Spacing (px)"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.letter_spacing_desc}
                                onChange={(new_val) => {
                                    props.setAttributes({ letter_spacing_desc: new_val })
                                }}
                            />

                            <PanelBody title={__("Text Shadow")} initialOpen={true}>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_color_desc: new_val })
                                    }}
                                    value={props.attributes.text_shadow_color_desc}
                                />
                                <RangeControl
                                    label="Horizontal (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.horizontal_desc}
                                    onChange={(new_val) => {
                                        props.setAttributes({ horizontal_desc: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Vertical (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.vertical_desc}
                                    onChange={(new_val) => {
                                        props.setAttributes({ vertical_desc: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Blur (px)"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.blur_desc}
                                    onChange={(new_val) => {
                                        props.setAttributes({ blur_desc: new_val })
                                    }}
                                />
                            </PanelBody>
                        </PanelBody>

                        <PanelBody title={__("Spacing")} initialOpen={false}>
                            <RangeControl
                                label="Icon Margin Left"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.headingml}
                                onChange={(new_val) => {
                                    props.setAttributes({ headingml: new_val })
                                }}
                            />

                            <RangeControl
                                label="Icon Margin Right"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={10}
                                value={props.attributes.headingmr}
                                onChange={(new_val) => {
                                    props.setAttributes({ headingmr: new_val })
                                }}
                            />

                            <RangeControl
                                label="Icon Margin Top"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.headingmt}
                                onChange={(new_val) => {
                                    props.setAttributes({ headingmt: new_val })
                                }}
                            />

                            <RangeControl
                                label="Icon Margin Bottom"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.headingmb}
                                onChange={(new_val) => {
                                    props.setAttributes({ headingmb: new_val })
                                }}
                            />
                            <hr />

                            <RangeControl
                                label="Wrapper Padding Left"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.pl_wrap}
                                onChange={(new_val) => {
                                    props.setAttributes({ pl_wrap: new_val })
                                }}

                            />


                            <RangeControl
                                label="Wrapper Padding Right"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.pr_wrap}
                                onChange={(new_val) => {
                                    props.setAttributes({ pr_wrap: new_val })
                                }}

                            />

                            <RangeControl
                                label="Wrapper Padding Top"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.pt_wrap}
                                onChange={(new_val) => {
                                    props.setAttributes({ pt_wrap: new_val })
                                }}

                            />

                            <RangeControl
                                label="Wrapper Padding Bottom"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.pb_wrap}
                                onChange={(new_val) => {
                                    props.setAttributes({ pb_wrap: new_val })
                                }}

                            />

                            <hr />
                            <RangeControl
                                label="Icon Padding"
                                min={0}
                                max={200}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.icon_padding}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_padding: new_val })
                                }}

                            />
                        </PanelBody>

                        <PanelBody title={__("Colors")} initialOpen={false}>
                            <p>Icon  Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.icon_clr }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_clr: new_val })

                                }}
                                value={props.attributes.icon_clr}
                            />
                            <hr />
                            <p>Title Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.text_colr }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ text_colr: new_val })

                                }}
                                value={props.attributes.text_colr}
                            />
                            <hr />
                            <p>Paragraph  Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.para_clr }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ para_clr: new_val })

                                }}
                                value={props.attributes.para_clr}
                            />
                            <hr />
                            <p>Background Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.bg_wrap }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_wrap: new_val })

                                }}
                                value={props.attributes.bg_wrap}
                            />
                            <hr />
                            <p style={{ fontSize: "10px", fontStyle: "italic", color: "gray" }}>To see the changes please select border style first in border panel</p>
                            <p>Icon Border Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.ic_b_clr }}
                            /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ ic_b_clr: new_val })

                                }}
                                value={props.attributes.ic_b_clr}
                            />
                            <hr />
                            <p>Icon Background Color <span> <ColorIndicator
                                style={{ backgroundColor: props.attributes.ic_bg_clr }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    props.setAttributes({ ic_bg_clr: new_val })

                                }}
                                value={props.attributes.ic_bg_clr}
                            />

                        </PanelBody>

                        <PanelBody title={__("Border")} initialOpen={false}>
                            <RangeControl
                                label="Icon Border"
                                min={0}
                                max={200}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.icon_border}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_border: new_val })
                                }}
                            />
                            <RangeControl
                                label="Icon Border Radius"
                                min={0}
                                max={200}
                                step={0.1}
                                initialPosition={0}
                                value={props.attributes.icon_radius}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_radius: new_val })
                                }}
                            />

                            <SelectControl
                                label="Border Style"
                                options={[
                                    { label: 'None', value: 'none' },
                                    { label: 'Solid', value: 'solid' },
                                    { label: 'Dotted', value: 'dotted' },
                                    { label: 'Dashed', value: 'dashed' },
                                    { label: 'Double', value: 'double' },
                                    { label: 'Inset', value: 'inset' },
                                ]}
                                value={props.attributes.border_style}
                                onChange={(new_val) => {
                                    props.setAttributes({ border_style: new_val })
                                }}
                            />

                            <RangeControl
                                label="Wrapper Border Radius"
                                min={0}
                                max={200}
                                step={0.1}
                                value={props.attributes.wrap_border_radius}
                                onChange={(new_val) => {
                                    props.setAttributes({ wrap_border_radius: new_val })
                                }}
                            />
                        </PanelBody>

                    </InspectorControls>

                    <BlockControls>
                        <AlignmentToolbar
                            value={props.attributes.text_alignment}
                            onChange={(new_val) => {
                                props.setAttributes({ text_alignment: new_val });
                            }} />
                    </BlockControls>
                    <div className="bb-ib-wrapper"
                        style={{
                            textAlign: props.attributes.text_alignment,
                            backgroundColor: props.attributes.bg_wrap,
                            paddingTop: props.attributes.pt_wrap,
                            paddingRight: props.attributes.pr_wrap,
                            paddingBottom: props.attributes.pb_wrap,
                            paddingLeft: props.attributes.pl_wrap,
                            display: props.attributes.display_default,
                            borderRadius: props.attributes.wrap_border_radius,

                        }}>

                        <div className="bb-ib-icon" style={{ alignSelf: props.attributes.alg }}>
                            <a href="" style={{}}>
                                <span className={props.attributes.icon_selector}
                                    style={{
                                        fontSize: props.attributes.icon_size,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        color: props.attributes.icon_clr,
                                        backgroundColor: props.attributes.ic_bg_clr,
                                        padding: props.attributes.icon_padding,
                                        borderWidth: props.attributes.icon_border,
                                        borderStyle: props.attributes.border_style,
                                        borderColor: props.attributes.ic_b_clr,
                                        borderRadius: props.attributes.icon_radius,
                                    }}
                                ></span></a>
                        </div>
                        <div className="bb-ib-heading">
                            <RichText className="bb-ib-content-heading"
                                style={{
                                    fontFamily: props.attributes.title_family,
                                    fontWeight: props.attributes.title_weight,
                                    textTransform: props.attributes.title_transform,
                                    textDecoration: props.attributes.title_decoration,
                                    fontSize: props.attributes.font_sizeib,
                                    textShadow: props.attributes.horizontal_title + 'px' + ' ' + props.attributes.vertical_title + 'px' + ' ' + props.attributes.blur_title + 'px' + ' ' + props.attributes.text_shadow_color_title,
                                    lineHeight: props.attributes.title_height + "em",
                                    letterSpacing: props.attributes.letter_spacing_title,
                                    color: props.attributes.text_colr,
                                    margin: "0px",
                                }}
                                tagName={props.attributes.ibheadingtag}
                                value={props.attributes.ibheading}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibheading: new_val })
                                }}


                            />




                            <RichText className="bb-ib-content-description"
                                style={{
                                    fontFamily: props.attributes.description_family,
                                    fontWeight: props.attributes.description_weight,
                                    textTransform: props.attributes.description_transform,
                                    textDecoration: props.attributes.description_decoration,
                                    textShadow: props.attributes.horizontal_desc + 'px' + ' ' + props.attributes.vertical_desc + 'px' + ' ' + props.attributes.blur_desc + 'px' + ' ' + props.attributes.text_shadow_color_desc,
                                    fontSize: props.attributes.description_sizeib,
                                    lineHeight: props.attributes.description_line_Height + "em",
                                    letterSpacing: props.attributes.letter_spacing_desc,
                                    color: props.attributes.para_clr
                                }}
                                tagName="p"
                                value={props.attributes.ibpara}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibpara: new_val })
                                }}


                            />

                        </div>
                    </div>


                    {/* dosra */}

                    <div className="bb-ib-wrapper"
                        style={{
                            textAlign: props.attributes.text_alignment,
                            backgroundColor: props.attributes.bg_wrap,
                            paddingTop: props.attributes.pt_wrap,
                            paddingRight: props.attributes.pr_wrap,
                            paddingBottom: props.attributes.pb_wrap,
                            paddingLeft: props.attributes.pl_wrap,
                            display: props.attributes.display_left,
                            justifyContent: "center",
                            flexDirection: "row",
                            borderRadius: props.attributes.wrap_border_radius,

                        }}>

                        <div className="bb-ib-icon"
                            style={{
                                alignSelf: props.attributes.alg
                            }}

                        >
                            <a href=""
                                style={{

                                }}

                            >

                                <span className={props.attributes.icon_selector}
                                    style={{
                                        fontSize: props.attributes.icon_size,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        color: props.attributes.icon_clr,
                                        backgroundColor: props.attributes.ic_bg_clr,
                                        padding: props.attributes.icon_padding,
                                        borderWidth: props.attributes.icon_border,
                                        borderStyle: props.attributes.border_style,
                                        borderColor: props.attributes.ic_b_clr,
                                        borderRadius: props.attributes.icon_radius,

                                    }}
                                ></span></a>
                        </div>


                        <div className="bb-ib-heading">
                            <RichText
                                style={{
                                    fontFamily: props.attributes.title_family,
                                    fontWeight: props.attributes.title_weight,
                                    textTransform: props.attributes.title_transform,
                                    textDecoration: props.attributes.title_decoration,
                                    fontSize: props.attributes.font_sizeib,
                                    textShadow: props.attributes.horizontal_title + 'px' + ' ' + props.attributes.vertical_title + 'px' + ' ' + props.attributes.blur_title + 'px' + ' ' + props.attributes.text_shadow_color_title,
                                    lineHeight: props.attributes.title_height + "em",
                                    letterSpacing: props.attributes.letter_spacing_title,
                                    color: props.attributes.text_colr,
                                    margin: "0px",
                                }}
                                tagName={props.attributes.ibheadingtag}
                                value={props.attributes.ibheading}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibheading: new_val })
                                }}
                            />

                            <RichText
                                style={{
                                    fontFamily: props.attributes.description_family,
                                    fontWeight: props.attributes.description_weight,
                                    textTransform: props.attributes.description_transform,
                                    textDecoration: props.attributes.description_decoration,
                                    fontSize: props.attributes.description_sizeib,
                                    textShadow: props.attributes.horizontal_desc + 'px' + ' ' + props.attributes.vertical_desc + 'px' + ' ' + props.attributes.blur_desc + 'px' + ' ' + props.attributes.text_shadow_color_desc,
                                    lineHeight: props.attributes.description_line_Height + "em",
                                    letterSpacing: props.attributes.letter_spacing_desc,
                                    color: props.attributes.para_clr
                                }}
                                tagName="p"
                                value={props.attributes.ibpara}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibpara: new_val })
                                }}


                            />

                        </div>
                    </div>



                    {/* 3sra */}

                    <div className="bb-ib-wrapper"
                        style={{
                            textAlign: props.attributes.text_alignment,
                            backgroundColor: props.attributes.bg_wrap,
                            paddingTop: props.attributes.pt_wrap,
                            paddingRight: props.attributes.pr_wrap,
                            paddingBottom: props.attributes.pb_wrap,
                            paddingLeft: props.attributes.pl_wrap,
                            display: props.attributes.display_right,
                            justifyContent: "center",
                            flexDirection: "row-reverse",
                            borderRadius: props.attributes.wrap_border_radius,

                        }}>

                        <div className="bb-ib-icon"
                            style={{
                                alignSelf: props.attributes.alg
                            }}>
                            <a href=""
                                style={{

                                }}

                            >

                                <span className={props.attributes.icon_selector}
                                    style={{
                                        fontSize: props.attributes.icon_size,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        color: props.attributes.icon_clr,
                                        backgroundColor: props.attributes.ic_bg_clr,
                                        padding: props.attributes.icon_padding,
                                        borderWidth: props.attributes.icon_border,
                                        borderStyle: props.attributes.border_style,
                                        borderColor: props.attributes.ic_b_clr,
                                        borderRadius: props.attributes.icon_radius,

                                    }}
                                ></span></a>
                        </div>


                        <div className="bb-ib-heading">
                            <RichText
                                style={{
                                    fontFamily: props.attributes.title_family,
                                    fontWeight: props.attributes.title_weight,
                                    textTransform: props.attributes.title_transform,
                                    textDecoration: props.attributes.title_decoration,
                                    fontSize: props.attributes.font_sizeib,
                                    textShadow: props.attributes.horizontal_title + 'px' + ' ' + props.attributes.vertical_title + 'px' + ' ' + props.attributes.blur_title + 'px' + ' ' + props.attributes.text_shadow_color_title,
                                    lineHeight: props.attributes.title_height + "em",
                                    letterSpacing: props.attributes.letter_spacing_title,
                                    color: props.attributes.text_colr,
                                    margin: "0px",
                                }}
                                tagName={props.attributes.ibheadingtag}
                                value={props.attributes.ibheading}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibheading: new_val })
                                }}


                            />




                            <RichText
                                style={{
                                    fontFamily: props.attributes.description_family,
                                    fontWeight: props.attributes.description_weight,
                                    textTransform: props.attributes.description_transform,
                                    textDecoration: props.attributes.description_decoration,
                                    fontSize: props.attributes.description_sizeib,
                                    textShadow: props.attributes.horizontal_desc + 'px' + ' ' + props.attributes.vertical_desc + 'px' + ' ' + props.attributes.blur_desc + 'px' + ' ' + props.attributes.text_shadow_color_desc,
                                    lineHeight: props.attributes.description_line_Height + "em",
                                    letterSpacing: props.attributes.letter_spacing_desc,
                                    color: props.attributes.para_clr
                                }}
                                tagName="p"
                                value={props.attributes.ibpara}
                                onChange={(new_val) => {
                                    props.setAttributes({ ibpara: new_val })
                                }}


                            />

                        </div>
                    </div>

                </div>
            </React.Fragment>
        )

    },

    save: (props) => {
        return (null)
    }
})